





























import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class AvailableFieldsCard extends Vue {
  availableFields = [
    { key: 'name', text: 'Full name of the recipient' },
    { key: 'givenName', text: 'First name of the recipient' },
    { key: 'surname', text: 'Surname of the recipient' },
    { key: 'email', text: 'Email of the recipient'}
  ]
}
